import React, { useState } from "react";

const CancelOrderForm = ({
    reason,
    setReason,
    reasonList,
    comments,
    setComments,
    loading,
    openModal
}) => {

    const [errors, setErrors] = useState({});

    const validateForm = () => {

        const newErrors = {};

        if (!reason) {
            newErrors.reason = "Please select cancellation reason";
        }

        if (!comments.trim()) {
            newErrors.comments = "Comments are required";
        }
        else if (comments.trim().length < 5) {
            newErrors.comments = "Comments must be at least 5 characters";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!validateForm()) return;

        openModal();
    };

    return (
        <div className="cancel-order-form">

            <h2>Cancel Order</h2>

            <form onSubmit={handleSubmit}>

                <label>
                    Reason <span>*</span>
                </label>

                <select
                    value={reason}
                    onChange={(e) => {
                        setReason(e.target.value);
                        setErrors(prev => ({ ...prev, reason: "" }));
                    }}
                >
                    <option value="">Select Reason</option>

                    {reasonList.map((r) => (
                        <option key={r.id} value={r.id}>
                            {r.reason}
                        </option>
                    ))}

                </select>

                {errors.reason && (
                    <p className="form-error">{errors.reason}</p>
                )}

                <label>
                    Comments <span>*</span>
                </label>

                <textarea
                    value={comments}
                    onChange={(e) => {
                        setComments(e.target.value);
                        setErrors(prev => ({ ...prev, comments: "" }));
                    }}
                    placeholder="Eg: Ordered by mistake"
                />

                {errors.comments && (
                    <p className="form-error">{errors.comments}</p>
                )}

                <button
                    className="cancel-btn"
                    disabled={loading}
                >
                    Cancel Order
                </button>

            </form>

        </div>
    );
};

export default CancelOrderForm;